import { refs, domReady, booleanDataset } from '../modules/utils.js';

class EditorialBox4 extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const index = parseInt(newValue);
      this.refs.listItems?.forEach((el, i) => booleanDataset(el, 'active', index === i));
      this.refs.contentItems?.forEach((el, i) => booleanDataset(el, 'active', index === i));
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.dataset.index = 0;
  }

  #listeners() {
    this.refs.listItems?.forEach((el) => {
      el.addEventListener('click', () => {
        this.dataset.index = this.refs.listItems.indexOf(el);
      });
    });
  }
}

customElements.define('editorial-box-4', EditorialBox4);
